module.exports = __webpack_public_path__ + "static/media/mainBgPink2.451530aa.png";